export const DEAL_PARAM = "d";
